
// import { Modal } from 'bootstrap';
import '../styles/main.scss';

import app from './app';
import bxloader from './app/inits/bxloader';


// page on ready
function onReady()
{
	app.init();
	bxloader();

	let AboutPopupLink = document.querySelector('[data-about-popup-link]'),
		ReadPopupLink = $('[data-read-popup-link]'),
		PopupClose = $('[data-popup-close]'),
		mobileMenuLink = $('[data-mobile-menu]'),
		bookCheckbox = $('[data-book-check]'),
		accountZavetLinkV = $('[data-account-zavet-veth]'),
		accountZavetLinkN = $('[data-account-zavet-new]'),
		accountZavetBlockV = $('[data-account-zavet-veth-block]'),
		accountZavetBlockN = $('[data-account-zavet-new-block]');

	// close all popup
	PopupClose.on('click', function(e) {
		$('.read-popup').hide();
		$('.popup-wrapper').removeClass('show');
		e.preventDefault();
	});

	AboutPopupLink.addEventListener('click', event => {
		event.preventDefault();

		const AboutPopup = document.querySelector('[data-about-popup]');
		const instanceModal = Modal.open({
			title: null,
			content: AboutPopup.firstElementChild,
		});
	});

	mobileMenuLink.on('click', function (e) {
		$(this).toggleClass('active');
		$('.header-nav').toggle();
		e.preventDefault();
	});

	ReadPopupLink.on('click', function(e){

		$('.read-popup').show();
		$('.read-popup').css('height',$('.slick-slider').height());
		$('.read-popup').css('top',$('header').outerHeight());
		e.preventDefault();
	});

	bookCheckbox.on('change', function(e) {
		$(this).parents('label').toggleClass('active');
	});

	accountZavetLinkV.on('click', function(e){
		if (!$(this).hasClass('book-readed-list__zavet-link--active')) {
			$(this).addClass('book-readed-list__zavet-link--active');
			accountZavetLinkN.removeClass('book-readed-list__zavet-link--active');
			accountZavetBlockV.show();
			accountZavetBlockN.hide();
			$('.book-readed-choice--v').show();
			$('.book-readed-choice--n').hide();
		}
		e.preventDefault();
	});


	accountZavetLinkN.on('click', function(e){
		if (!$(this).hasClass('book-readed-list__zavet-link--active')) {
			$(this).addClass('book-readed-list__zavet-link--active');
			accountZavetLinkV.removeClass('book-readed-list__zavet-link--active');
			accountZavetBlockV.hide();
			accountZavetBlockN.show();
			$('.book-readed-choice--v').hide();
			$('.book-readed-choice--n').show();
		}
		e.preventDefault();
	});


	// READED BOOKS
	let readedBookLink = $('[data-book-readed]'),
		readedVBookAll = $('[data-book-readed-v-all]'),
		readedNBookAll = $('[data-book-readed-n-all]');


	readedBookLink.on('click', function (e) {
		let currentBooktBlockID = $(this).data('book');
		if ($(this).parent('.book-readed-choice').hasClass('book-readed-choice--v')) {
			$('.veth-list .book-block').hide();
		} else {
			$('.zavet-list .book-block').hide();
		}
		$('.book-block[data-book="'+currentBooktBlockID+'"]').show();
		$(this).parent('.book-readed-choice').find('.book-readed-choice--active').removeClass('book-readed-choice--active');
		$(this).addClass('book-readed-choice--active');
		e.preventDefault();
	});


	readedVBookAll.on('click', function (e) {
		$(this).parent('.book-readed-choice').find('.book-readed-choice--active').removeClass('book-readed-choice--active');
		$(this).addClass('book-readed-choice--active');
		$('.veth-list .book-block').show();
		e.preventDefault();
	});


	readedNBookAll.on('click', function (e) {
		$(this).parent('.book-readed-choice').find('.book-readed-choice--active').removeClass('book-readed-choice--active');
		$(this).addClass('book-readed-choice--active');
		$('.zavet-list .book-block').show();
		e.preventDefault();
	});
}


BX.ready(onReady);
if (window.frameCacheVars !== undefined)
{
	BX.addCustomEvent("onFrameDataReceived", (json) => {
		if (!(json.dynamicBlocks || []).length)
		{
			return;
		}

		json.dynamicBlocks.forEach((block, index) =>
		{
			app.init([], document.querySelector(block.ID));
		})
	});
}
